import { formatPrice } from './priceFormatter';

export const calculateCrossedPrice = (
  price: number,
  currencySymbol?: string,
) => {
  const markupFactor = 1.1;
  const adjustedPrice = price * markupFactor;
  return formatPrice(adjustedPrice, { currencySymbol }); // Use a helper function to format the price
};

export const calculateAdjustedPrice = (price: number) => {
  return price;
};
